
import { Component, Prop } from 'nuxt-property-decorator'
import type VueI18n from 'vue-i18n'
import { OnMounted } from '~/core/vue.types'
import { addressObservable } from '~/observables/modules/address'
import AddressMixin from '~/mixins/address.mixin'

@Component({
})
export default class AddressFilter extends AddressMixin implements OnMounted {
  @Prop({
    required: true,
    type: Boolean,
  })
  readonly isAddressRequired!: boolean

  @Prop({
    required: true,
    type: String,
  })
  readonly postfix!: string

  @Prop({ type: String })
  readonly title?: VueI18n.TranslateResult

  mounted () {
    if (!addressObservable.zip) {
      this.resetAddressField()
    }
  }
}
